<template>
  <div class="kr-layout-content">
    <!--左边-->
    <div class="content-left">
      <!--最新文章-->
      <div class="new-article">
        <ul class="art-list">
          <li v-for="(item,index) in essay" :key="index" @click=" details(item.id)">
            <div class="head-img">
              <img :src="item.pic" alt />
            </div>
            <div class="content">
              <div class="title">
                <!-- <span>艺术</span> -->
                <p class="twoline">{{item.title}}</p>
              </div>
              <p class="intro oneline">{{item.subTitle }}</p>
              <div class="author">
                <p class="name oneline">{{item.createTime}}</p>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loadmore" class="look-more" @click="addMore">查看更多</div>
		<p v-if="!loadmore" class="none-more">没有更多了</p>
      </div>
    </div>

    <!--右边-->
    <div class="content-right">
      <div class="user-data">
        <div class="user">
          <div class="user-img">
            <img :src="content.userHeadPic" alt />
          </div>
          <div class="cont">
            <p class="nick oneline">{{content.userName}}</p>
            <!-- <span class="rank">新锐作者</span> -->
            <span class="rank care" @click="careAuthor" v-text="isFocusEd==0?'关注':'已关注'"></span>
          </div>
        </div>
        <p class="msg">{{content.keyWorks}}</p>
        <p class="msg">发表{{count}}篇文章</p>
      </div>
    </div>
  </div>
</template>
<script>
import { log } from "util";
export default {
  //   name: "App",
  data() {
    return {
      userId: this.$route.query.userId,
      id: this.$route.query.id,
      count: this.$route.query.count,
      essay: [],
      content: {},
      isFocusEd: 0,
      firendId: "",
      userName: "",
	  page:1,
	  loadmore:true
    };
  },
  methods: {
	  addMore(){ //加载更多
		  this.page++
		  this.check()
	  },
    // 查询作者个人数据
    check() {
      this.$http
        .get("/api/core/002--newsList", {
          params: {
            type: 1,
            userId: this.userId,
			pageNo:this.page
          }
        })
        .then(res => {
          console.log(res, "个人数据");
          if (res.status == 200 && res.data.code == 0) {
            if (res.data.rows.length > 0) {
			  if(this.page==1){
				  this.essay = res.data.rows;
				  this.getData(res.data.rows[0].id);
			  }else{
				  this.essay = this.essay.concat(res.data.rows)
			  }
            }
			if (this.page >= res.data.totalPage) {
			  this.loadmore = false;
			}
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取数据
    getData(id) {
      console.log(id);
      this.$http
        .get("/api/core/002-1--newsDetail", {
          params: {
            id: id,
			limit:10,
			page:this.page
          }
        })
        .then(res => {
          // console.log(res, "详情");
          if (res.status == 200 && res.data.code == 0) {
            this.content = res.data.rows[0];
            this.firendId = res.data.rows[0].userId;
            this.userName = res.data.rows[0].userName;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    careAuthor() {
      //关注
      this.$http
        .get("/api/core/009-userFocusPc", {
          params: {
            token: this.$store.state.userInfo.token,
            type: 1,
            friendId: this.content.userId,
            friendName: this.content.userName
          }
        })
        .then(res => {
          // console.log(res, "关注");
          if (res.status == 200 && res.data.code == 0) {
            if (res.data.msg == "取关成功") {
              this.isFocusEd = 0;
            } else {
              this.isFocusEd = 1;
            }
          } else {
            this.$message(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    details(id) {
      //进入个人主页
      this.$router.push({
        path: "/ghDetails",
        query: { id: id, type: 1 }
      });
    }
  },
  mounted() {
    this.check();
  }
};
</script>
<style scoped>
.new-article .art-list > li .content .author {
  width: 444px;
}
.new-article .art-list > li .content .author .name {
  padding: 0px;
}
</style>